import React, { useContext, useMemo } from "react";
import { Route, useLocation, Redirect } from "react-router-dom";

import { Context as AuthContext } from "../../Context/AuthContext";
import { Context as PermissoesContext } from "../../Context/PermissoesContext";
import { ROTAS_COM_PERMISSAO } from "../../config/routePermissions";

import Loading from "../Loading";

export default function CustomRoute({ isPrivate, requiredPermission, path, ...rest }) {
  const { loading: authLoading, authenticated } = useContext(AuthContext);
  const { permissoes, checarPermissao } = useContext(PermissoesContext);
  const location = useLocation();
  let url = location.pathname;

  const regraAtual = useMemo(() => {
    if (requiredPermission) {
      return { pathPrefix: path || url, requiredPermissions: requiredPermission };
    }

    const normalizedUrl = url.toLowerCase();
    const ordenado = [...ROTAS_COM_PERMISSAO].sort(
      (a, b) => b.pathPrefix.length - a.pathPrefix.length
    );
    return ordenado.find(r => normalizedUrl.startsWith(r.pathPrefix.toLowerCase())) ?? null;
  }, [requiredPermission, path, url]);

  const permissaoRequerida = regraAtual?.requiredPermissions;
  const deveAvaliar = !!permissaoRequerida;

  const hasPermission = useMemo(() => {
    if (!deveAvaliar) {
      return true;
    }
    if (permissoes.length === 0) {
      return null;
    }

    const permissoesArray = Array.isArray(permissaoRequerida) 
      ? permissaoRequerida 
      : [permissaoRequerida];

    return permissoesArray.some(perm => checarPermissao(perm));
  }, [deveAvaliar, permissaoRequerida, permissoes, checarPermissao]);

  if (authLoading) {
    return <Loading />;
  }

  if (deveAvaliar && permissoes.length === 0) {
    return <Loading />;
  }

  if (isPrivate && !authenticated) {
    return <Redirect to={`/login${url}`} />;
  }

  if (authenticated && url.includes("/login")) {
    url = url.replaceAll("/login", "");
    return <Redirect to={url} />;
  }

  if (deveAvaliar && hasPermission === false) {
    return <Redirect to="/home" />;
  }

  return <Route {...rest} />;
}
